import React from 'react';
import { Box, Container, Typography } from '@mui/material';


const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL


const NotFoundPage = () => {

    return (
        <Container
            component="main"
            sx={{
                marginTop: 4,
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height:"60vh" 
            }}
        >
            <Box
                sx={{
                    bgcolor: 'primary.light', // Default background color
                    p: .5,
                    mb: 2,
                    width: '300px',
                    textAlign: 'center',
                    color: 'black', // Text color
                    borderRadius: 2,
                    border: 3,
                    boxShadow: 6
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: 'inherit', p: 2 }}>I'M SORRY THAT PAGE IS IN ANOTHER CASTLE</Typography>

                <Box sx={{p:2}}>
                    <img
                        loading="lazy"
                        src={`${IMAGE_URL}char_gifs/misc/lakitu_reverse.webp`}
                        style={{ minWidth: "200px", width: "70%" }}
                        alt="Chosen Map"

                    />
                </Box>
            </Box>



        </Container>
    );
}

export default NotFoundPage;

// src={`${IMAGE_URL}headers/SoLongGayBowser.png`}